export interface VisitorType {
  key: string;
  label: string;
  description: string;
  image: string;
}

export interface VisitorTypeDefinition extends VisitorType {
  visitTypeId?: number;
  ipadFlag?: string;
  qrFlag?: string;
}

/** Types de visiteurs communs aux deux parcours (iPad et QR). */
export const VISITOR_TYPES: VisitorTypeDefinition[] = [
  {
    key: 'visitor',
    label: 'vues.ipad.type.visitor.label',
    description: 'vues.ipad.type.visitor.desc',
    image: '/assets/images/ipad/visitor.jpg',
    visitTypeId: 1,
    ipadFlag: 'dS_NewVisitor',
    qrFlag: 'dS_Visitor_QrCodeScanner',
  },
  {
    key: 'group',
    label: 'vues.ipad.type.group.label',
    description: 'vues.ipad.type.group.desc',
    image: '/assets/images/ipad/group.jpg',
    visitTypeId: 1,
    ipadFlag: 'dS_MultipleVisitors',
  },
  {
    key: 'contractor',
    label: 'vues.ipad.type.contractor.label',
    description: 'vues.ipad.type.contractor.desc',
    image: '/assets/images/ipad/contractor.jpg',
    visitTypeId: 2,
    ipadFlag: 'dS_Contractor',
    qrFlag: 'dS_Contractor_QrCodeScanner',
  },
  {
    key: 'employee',
    label: 'vues.ipad.type.employee.label',
    description: 'vues.ipad.type.employee.desc',
    image: '/assets/images/ipad/employee.jpg',
    visitTypeId: 3,
    ipadFlag: 'dS_Employee',
    qrFlag: 'dS_Employee_QrCodeScanner',
  },
  {
    key: 'delivery',
    label: 'vues.ipad.type.delivery.label',
    description: 'vues.ipad.type.delivery.desc',
    image: '/assets/images/ipad/delivery.jpg',
    ipadFlag: 'dS_Delivery',
  },
  {
    key: 'trucker',
    label: 'vues.ipad.type.trucker.label',
    description: '',
    image: '',
    qrFlag: 'dS_Trucker_QrCodeScanner',
  },
];

export type VisitorTypeChannel = 'ipad' | 'qr';

/** Types proposes par un canal, avant filtrage par la configuration du site. */
export function visitorTypesForChannel(channel: VisitorTypeChannel): VisitorTypeDefinition[] {
  return VISITOR_TYPES.filter(type => (channel === 'ipad' ? type.ipadFlag : type.qrFlag));
}

/** Types visibles pour un site : options activees dans l'admin. */
export function visibleVisitorTypes(channel: VisitorTypeChannel, pos: any): VisitorTypeDefinition[] {
  const types = visitorTypesForChannel(channel);
  if (!pos) return types;

  return types.filter(type => {
    const flag = channel === 'ipad' ? type.ipadFlag : type.qrFlag;
    return flag ? !!pos[flag] : false;
  });
}

/** Identifiant de visite pour un type (1 visiteur, 2 contracteur, 3 employe). */
export function visitTypeIdOf(key: string | undefined): number {
  return VISITOR_TYPES.find(type => type.key === key)?.visitTypeId ?? 1;
}
